import styled from "styled-components";

export const CategoryBarContainer = styled.div`
  position: fixed;
  margin-top: 12.5rem;
  transition: all 0.3s ease-in-out;
  display: flex;
  background: white;
  box-shadow: 0px 0px 10px 5px rgba(0, 0, 0, 0.05);
  flex-direction: column;
  min-width: 26rem;
  max-width: 26rem;
  z-index: 10;
  user-select: none;
  top: 0;
  bottom: 0;
  left: ${(props) => (props.$ar ? "unset" : 0)};
  right: ${(props) => (props.$ar ? 0 : "unset")};
  padding: 1.5rem;

  @media (max-width: 870px) {
    display: none;
  }
`;
export const LoaderContainer = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
`;

export const CategoryList = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  margin-bottom: 10px;
  width: 100%;
  gap: 5px;
`;

export const Category = styled.span`
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  opacity: ${(props) => (props.$active ? 1 : 0.6)};
  text-decoration: none;
  color: #484888;
  font-family: "Avenir-Medium";
  gap: 1rem;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.0666667px;
  transition: all 0.2s ease-in-out;
  padding: 1rem 2rem;
  width: 100%;
  cursor: pointer;
  white-space: nowrap;

  border-bottom: 1px solid #f4efee;

  &:hover {
    opacity: 1;
  }
`;

export const Title = styled.span`
  font-family: "Avenir-Black", sans-serif;
  font-size: 35px;
  letter-spacing: -0.177777px;

  color: #fff;
`;
